import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-ticket-types',
  templateUrl: './ticket-types.component.html',
  styleUrls: ['./ticket-types.component.css']
})
export class TicketTypesComponent implements OnInit {

  data: any;
  cid:any
  form: any | FormGroup
  editForm: any | FormGroup
  modelSubtitle = false
  tickettypeId: any
  tickets: any = []
  checked = false


  name = ""
  version = ""
  isActive = false
  i: any;
  deleteId: any = "";
  serviceData: any = []
  isLoading: any = false
  actionControls: any = {
    isAdd: false, 
    isView: false, 
    isDelete: false, 
    isModify: false 
  }

  searchKey: any = ""
  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;
  first: number = 0;

  recordName: any = ""
  recordId: any = ""
  formSubmit: boolean = false;


 constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    let href:any = window.location.href;
    let messages = href.split('/') 
    let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
    this.actionControls = action

    this.cid = sessionStorage.getItem('cid')
    // this.getalltickets()
    this.getAllTicketTypeWithPagination(this.pageNumber,this.recordsPerPage)

    this.form = this.fb.group({
      name: ['',[Validators.required]],
      version: [''],
      serviceType: [''],
      isPubliclyVisible: false
    })

    this.editForm = this.fb.group({
      name: ['',[Validators.required]],
      version: [''],
      serviceType: [''],
      isPubliclyVisible: true,
      isActive: [''],
      id: ['']
    })
    this.getAllServices()
  }

  onTableDataChange(event: any) {
    console.log(event)
    this.pageNumber = event.page;

    if(this.searchKey != ""){
      this.getTicketTypeByWildSearch(this.pageNumber,this.recordsPerPage)
    }else{
      this.getAllTicketTypeWithPagination(this.pageNumber,this.recordsPerPage)
    }

  }

  addTicketType(){

  if(this.formSubmit){
    return
  }

  if(!this.form.valid){
    this.toastr.error("Please fill in all required fields");
    this.formSubmit = false;
    return
  }



  this.formSubmit = true;

    let body = {
      "version": Number(this.form.get('version').value),
      "isActive": true,
      "description": "",
      "serviceType": String(this.form.get('serviceType').value) || "",
      "name": String(this.form.get('name').value) || "",
      "remarks": "",
      "displayOrder": "",
      "isPubliclyVisible": this.form.get('isPubliclyVisible').value || false,
      "cid": Number(this.cid),
    }

    console.log(body)
    this.generic_service.addTicket(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.getAllTicketTypeWithPagination(this.pageNumber,this.recordsPerPage)
        this.toastr.success(response.message);
        this.cancelModel()
    this.formSubmit = false;


      },
      (err:any)=>{
        console.log(err)
    this.formSubmit = false;

        this.toastr.error(err.error.errors[0].description);

      },
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
    document.getElementById("closeModalButton2")?.click()
  }

  // getalltickets(){
  //   this.isLoading = true

  //   this.generic_service.getAllTickets().subscribe(
  //     (response:any)=>{
  //       this.tickets = response.response;
  //       this.totalRecords = response.response.length;

  //       console.log(response)
  //       this.isLoading = false

  //     }
  //   )
  // }

  radiocheck(){
    if(this.checked){
      this.checked = false
    }
    else{
      this.checked = true
    }
  }


  getAllTicketTypeWithPagination(pageNumber: any,recordsPerPage: any){
    this.isLoading = true

    this.generic_service.getAllTicketTypeWithPagination(pageNumber,recordsPerPage).subscribe(
      (response:any)=>{
        console.log(response)
        this.tickets = response.response.ticketTypeList;
        this.totalRecords = response.response.totalRecords;
        this.pageNumber = 0
        this.first = 0
        this.isLoading = false

      }
    )
  }

  editskill(){
    this.tickets[this.i].name=this.name
    this.tickets[this.i].version=this.version
    this.tickets[this.i].isActive = this.isActive;
    this.close()
  }

  open() {
    this.modelSubtitle = true;
  }
  close() {
    this.modelSubtitle = false;
    this.name = ""
    this.version = ""
    this.isActive = false
    
  }

  edit(i:any){
    this.open();
    this.name = this.tickets[i].name;
    this.version = this.tickets[i].version;
    this.isActive = this.tickets[i].isActive
  }

  getAllServices(){
    this.generic_service.getAllServices().subscribe(
      (response:any)=>{
        this.serviceData = response.response;
        console.log(response)
      }
    )
  }
 
  deleleTicketType(){
    this.generic_service.deleteTicketType(this.deleteId).subscribe(
     (res:any)=>{
      this.toastr.success("Successfully Deleted");
      this.getAllTicketTypeWithPagination(this.pageNumber,this.recordsPerPage)
      this.cancelModel();
      this.clearData()
     },err=>{
      this.toastr.error(err.errors[0].description);
     }
    )
  }
 
  del(id:any,list: any){
    this.deleteId = id    
    this.recordId = list.ticketTypeId;
    this.recordName = list.name;

  }


 getTicketTypeById(id:any){
  this.tickettypeId = id
  this.generic_service.getTicketTypeById(id).subscribe(
    (response:any)=>{
      console.log(response)
      this.editForm.patchValue({
        name: response.response.name,
        version: response.response.version,
        isPubliclyVisible: response.response.isPubliclyVisible,
        isActive: response.response.isActive,
        serviceType: response.response.serviceType,
        id: response.response.id
      })
      console.log(this.editForm.value)
    },
    (error)=>{
      console.log(error)
    }
  )
}


updateTicketType(){

  if(this.formSubmit){
    return
  }

  if(!this.editForm.valid){
    this.toastr.error("Please fill in all required fields");
    this.formSubmit = false;
    return
  }



  this.formSubmit = true;


  let body = {
    "version": 0,
    "isActive": true,
    "description": "",
    "serviceType": String(this.editForm.get('serviceType').value),
    "id": this.editForm.get('id').value,
    "ticketTypeId": this.tickettypeId,
    "name": String(this.editForm.get('name').value),
    "remarks": "",
    "isPubliclyVisible": this.editForm.get('isPubliclyVisible').value,
    "displayOrder": "",
    "cid": Number(this.cid),
    
  }

  console.log(body)
  this.generic_service.updateTicketType(body).subscribe(
    (response:any)=>{
      console.log(response)
      this.getAllTicketTypeWithPagination(this.pageNumber,this.recordsPerPage)
      this.toastr.success("Successfully Updated");
      this.cancelModel()
    this.formSubmit = false;

    },
    (err:any)=>{
      console.log(err)
      this.formSubmit = false;
      this.toastr.error(err.errors[0].description);
    },
  )
}


getTicketTypeByWildSearch(pageNumber: any,recordsPerPage: any){
  if(this.searchKey != ""){
    this.isLoading = true

    this.generic_service.getTicketTypeByWildSearch(this.searchKey,pageNumber,recordsPerPage).subscribe(
      (response:any)=>{
        console.log(response);
        this.tickets = response.response.ticketTypeList;
        this.totalRecords = response.response.totalRecords;
        this.isLoading = false

      },
      (err:any)=>{
        console.log(err)
      }
    )
  }else{
    this.getAllTicketTypeWithPagination(this.pageNumber,this.recordsPerPage)
  }
}

  refreshSearch(){
    this.searchKey = ""
    this.getAllTicketTypeWithPagination(this.pageNumber,this.recordsPerPage)
  }

  clearData(){
    this.recordId = "";
    this.recordName = "";
    this.editForm.reset()
    this.form.reset()
  }

}
